document.addEventListener("DOMContentLoaded", function () {
  const buttonConn = document.querySelector('.stick_button_conn');

  if (!buttonConn) return; // Exit if the element is not found

  // Use passive listener and requestAnimationFrame for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        let scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition >= 500) {
          buttonConn.classList.add('visible_conn');
        } else {
          buttonConn.classList.remove('visible_conn');
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
});

//============= † Disclaimer popup code start ======================
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.disclaimer_pop_btn');

    buttons.forEach(button => {
      const container = button.closest('.discacler_popup_container');
      if (!container) return;

      const popup = container.querySelector('.discacler_popup_answer');
      if (!popup) return;

      // --- Desktop Hover Support ---
      button.addEventListener('mouseenter', () => {
        if (!isTouchDevice()) {
          container.classList.add('show-popup');
        }
      });

      button.addEventListener('mouseleave', () => {
        if (!isTouchDevice()) {
          container.classList.remove('show-popup');
        }
      });

      popup.addEventListener('mouseleave', () => {
        if (!isTouchDevice()) {
          container.classList.remove('show-popup');
        }
      });

      // --- Mobile Click Support ---
      button.addEventListener('click', function (e) {
        e.stopPropagation(); // prevent closing instantly
        container.classList.toggle('show-popup');

        // Close other open popups
        document.querySelectorAll('.discacler_popup_container').forEach(other => {
          if (other !== container) {
            // other.classList.remove('show-popup');
          }
        });
      });
    });

    // Click outside closes all
    document.addEventListener('click', function () {
      document.querySelectorAll('.discacler_popup_container').forEach(container => {
        container.classList.remove('show-popup');
      });
    });

    // Utility to detect touch device
    function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
  });
//============= † Disclaimer popup code end ======================



//============= search accordian code start ======================
document.addEventListener('DOMContentLoaded', () => {
  const toggleAccordion = (toggle, content, expand) => {
    if (!toggle || !content) return;
    toggle.setAttribute('aria-expanded', expand);
    content.hidden = !expand;
  };

  document.querySelectorAll('.cluster_accodian_search_conn').forEach(section => {
    // Cluster toggles
    section.querySelectorAll('.faq-toggle').forEach(toggle => {
      const content = section.querySelector(
        `#${CSS.escape(toggle.getAttribute('aria-controls'))}`
      );
      // toggleAccordion(toggle, content, true);

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggleAccordion(toggle, content, !expanded);
      });
    });

    // Nested question toggles
    section.querySelectorAll('.faq-subtoggle').forEach(subtoggle => {
      const content = section.querySelector(
        `#${CSS.escape(subtoggle.getAttribute('aria-controls'))}`
      );
      // toggleAccordion(subtoggle, content, false);

      subtoggle.addEventListener('click', () => {
        const expanded = subtoggle.getAttribute('aria-expanded') === 'true';
        toggleAccordion(subtoggle, content, !expanded);
      });
    });
  });

  // Search
  const searchInput = document.getElementById('faq-search');
  if (!searchInput) return;

searchInput.addEventListener('input', e => {
  const term = e.target.value.trim().toLowerCase();

  document.querySelectorAll('.cluster_accodian_search_conn').forEach(section => {
    let anyInSection = false;

    section.querySelectorAll('.faq-cluster').forEach(cluster => {
      let anyInCluster = false;

      cluster.querySelectorAll('.faq-question').forEach(q => {
        const h3 = q.querySelector('h3')?.textContent.toLowerCase() || '';
        const p = q.querySelector('p')?.textContent.toLowerCase() || '';
        const match = term !== '' && (h3.includes(term) || p.includes(term));

        const subtoggle = q.querySelector('.faq-subtoggle');
        const answer = section.querySelector(
          `#${CSS.escape(subtoggle?.getAttribute('aria-controls'))}`
        );

        if (match) {
          q.classList.add('search-match');
          q.style.display = '';
          toggleAccordion(subtoggle, answer, true);
          anyInCluster = true;
          anyInSection = true;
        } else {
          q.classList.remove('search-match');
          q.style.display = '';
          toggleAccordion(subtoggle, answer, false);
        }

        // Clear search-match class if no search term
        if (term === '') {
          q.classList.remove('search-match');
        }
      });

      const clusterToggle = cluster.querySelector('.faq-toggle');
      const clusterContent = section.querySelector(
        `#${CSS.escape(clusterToggle?.getAttribute('aria-controls'))}`
      );

      if (term && anyInCluster) {
        cluster.style.display = '';
        toggleAccordion(clusterToggle, clusterContent, true);
      } else if (term && !anyInCluster) {
        cluster.style.display = '';
        toggleAccordion(clusterToggle, clusterContent, false);
      } else {
        cluster.style.display = '';
        toggleAccordion(clusterToggle, clusterContent, false);
      }
    });

    section.style.display = '';
  });
});

});


//============= search accordian code end ======================



////////////////////////////////////////////////////////////////////////////////////////
const whySubscribe = () => {
  // Use requestAnimationFrame instead of setTimeout for better performance
  requestAnimationFrame(() => {
    setTimeout(() => {    
      if (document.querySelector('.why-subscribe')) return;
      const buyButtons = document.querySelector('body.product-page_current .product form.shopify-product-form .buy-buttons');
    if (buyButtons) {
      const whySubscribe = document.createElement('div');
      whySubscribe.className = 'why-subscribe';
      // <h3 class="why-subscribe-inner" style="cursor: pointer;"><p>Why Subscribe?</p><span><img src="https://cdn.shopify.com/s/files/1/0564/1555/1585/files/next_1.png?v=1751268224" alt="arrow-left" style="width: 16px; height:16px;"></span></h3>
      whySubscribe.innerHTML = `
        
        <div class="why-subscribe-content" style="display: none; margin-top:10px">
          <p><strong>Collagen renewal takes time.</strong></p>
          <p>You'll start to see the glow in one collagen cycle (≈ 90 days), but the biggest gains keep building with daily use. Stay on Advanced Skin Nutrition for at least 6 months for truly radiant, resilient skin.</p>
        </div>
      `;

      // Insert before buy buttons
      buyButtons.parentElement.insertBefore(whySubscribe, buyButtons);

      // Add toggle click handler
      const header = whySubscribe.querySelector('.why-subscribe-inner');
      const content = whySubscribe.querySelector('.why-subscribe-content');

      header.addEventListener('click', () => {
        const isVisible = content.style.display === 'block';
        content.style.display = isVisible ? 'none' : 'block';
        header?.classList.toggle('opend');
      });
    }
    }, 2000);
  });
};


function showSavingsInWrappers() {

  if(document.querySelector('.appstle_subscription_amount_wrapper[saveText]')) return;
  
  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
  }

  const wrappers = document.querySelectorAll('.appstle_subscription_amount_wrapper');

  wrappers.forEach(wrapper => {
    const discountedEl = wrapper.querySelector('.appstle_subscription_amount.transcy-money');
    const compareEl = wrapper.querySelector('.appstle_subscription_compare_amount.transcy-money');

    if (!discountedEl || !compareEl) return;
    
    const discountedPrice = parsePrice(discountedEl.innerText || discountedEl.textContent);
    const comparePrice = parsePrice(compareEl.innerText || compareEl.textContent);

    const margin = comparePrice - discountedPrice;
    const percentageOff = comparePrice ? ((margin / comparePrice) * 100).toFixed(0) : 0;

    if (margin > 0 && percentageOff > 0) {
      const saveMessage = `Save $${margin.toFixed(2)?.replace('.00', '')} (${percentageOff}%)`;
      wrapper.setAttribute('saveText', saveMessage)
    }
  });
}

// Optimize polling with exponential backoff
let subscriptionAttempts = 0;
let pollDelay = 200; // Start with 200ms
const maxAttempts = 30;

function pollSubscription() {
  if (document.querySelector('.appstle_subscription_amount_wrapper')) {
    showSavingsInWrappers();
    return;
  }
  
  if (++subscriptionAttempts >= maxAttempts) {
    return;
  }
  
  // Exponential backoff: increase delay gradually
  pollDelay = Math.min(pollDelay * 1.2, 2000);
  setTimeout(pollSubscription, pollDelay);
}

pollSubscription();



function updateStickyBarPriceFromSellingPlan() {
  const selectedPlan = document.querySelector('[name="selling_plan"]:checked');

  const wrapper =
    selectedPlan?.closest('.appstle_subscription_radio_wrapper') ||
    selectedPlan?.closest('.appstle_one_time_details_wrapper');

  const priceText = wrapper?.querySelector('.appstle_subscription_amount')?.innerText;

  if (!priceText) return;

  const button = document.querySelector('product-sticky-bar button');

  if (button) {
    let priceSpan = button.querySelector('.price-span');

    if (!priceSpan) {
      priceSpan = document.createElement('span');
      priceSpan.className = 'price-span';
      priceSpan.style.marginLeft = '8px';
      button.appendChild(priceSpan);
    }

    priceSpan.textContent = priceText;
  }
}



document.querySelector('body.product-page_current')?.addEventListener('click', function (e) {
  const target = e.target;
  const wrapperOption = target.closest('.appstle_subscription_wrapper_option');
  if (wrapperOption) {
    updateStickyBarPriceFromSellingPlan();
  }
});



const discHandle = () => {
  const disText = `† These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. All observations are drawn from published studies on individual ingredients; results may vary.`;
  const disDoubleText = `VISIA® is a registered trademark of Canfield Scientific, Inc. Used here for illustrative comparison purposes only.`;
  const percentpoint = `Percentile shift measured across 12 weeks of supplementation; baseline scan conducted two years prior.`;

  document.querySelectorAll('a[href="#disc-popup"], a[href="#disc-popup-double-dagger"], a[href="#percentpoint"]')?.forEach(a => { 
    
    a.classList.add('disclaimer_pop_btn');

    const setDisclaimer = (e) => {
      e.preventDefault();
      document.documentElement.style.setProperty('--discTextWIdth', (a.parentElement.parentElement.parentElement.parentElement.offsetWidth - 20) + 'px');
      a.getAttribute('href') === '#disc-popup-double-dagger' ? a.parentElement.setAttribute('dis_text', disDoubleText) 
      : a.getAttribute('href') === '#percentpoint' ? a.parentElement.setAttribute('dis_text', percentpoint)
      : a.parentElement.setAttribute('dis_text', disText);
    };

    const clearDisclaimer = () => a.parentElement?.removeAttribute('dis_text');

    if (window.innerWidth > 1100) {
      a.addEventListener('mouseenter', setDisclaimer);
      a.addEventListener('mouseleave', clearDisclaimer);
    } else {
      a.addEventListener('click', (e) => {
        setDisclaimer(e);

        const clickOutsideHandler = (event) => {
          if (!a.contains(event.target)) {
            clearDisclaimer();
            document.removeEventListener('click', clickOutsideHandler);
          }
        };

        setTimeout(() => document.addEventListener('click', clickOutsideHandler), 0);
      });
    }
  });
};




document.addEventListener("DOMContentLoaded", () => {
  whySubscribe();
  updateStickyBarPriceFromSellingPlan();
  discHandle();
});

document.addEventListener("readystatechange", () => {
  if (document.readyState === "complete") {
    whySubscribe();
    updateStickyBarPriceFromSellingPlan();
  }
});

///////////////////////////////////////////////////////////////////////////////////////////////